<template>
    <section class="steps__main modal">
        <v-card class="card">
            <!-- <h5>Bem vindo(a)!</h5> -->
            <component
              :is="componentsName"
              @goToLogin="goToLogon"
              @changeData="goToUnities">

              <template #header>
                <section class="step__header">
                     <h5>Bem vindo(a), {{ userData.name }}!</h5>
                     <v-btn
                        small
                        color="error"
                        icon
                        @click="closeSteps"
                        >
                        <v-icon small>mdi-close</v-icon>
                    </v-btn>
                </section>
               
                <!-- <v-col v-for="(item, index) in items" :key="index" cols="12">
                    <v-btn
                        color="blue darken-2"
                        outlined
                        rounded
                        block 
                    >{{ item }}</v-btn>
                </v-col> -->
              </template>
            </component>
        </v-card>
    </section>
</template>
<script>
import CurrentLogin from "./CurrentLogin-comp.vue";
import LoggedUser from "./LoggedUser-comp.vue";
import ChooseUnity from "./ChooseUnity-comp.vue";
import { mapGetters } from "vuex";

export default {
  name: "Sala-de-espera",
  data() {
    return {
        componentsName: "CurrentLogin",
        items:[
            'Gestor de RH - Unidade X',
            'Gestor de Teste - Unidade X',
            'Funcionário - Unidade Y',
            'Diretor - Unidade U'
        ]
    };
  },

  computed: {
    ...mapGetters({
      userData: "getCurrentUser",
    }),
    // disabledButton() {
    //   return this.componentName === "LoggingUser";
    // },
  },

  watch: {},

  mounted(){
  },

  created() {
  },

  methods: {
    closeSteps() {
      this.$emit("closeSteps");
    },
    
    goToUnities(){
        this.componentsName = "ChooseUnity"
    },

    goToLogon() {
      this.componentsName = "LoggedUser";
    }
  },

  components: { 
    ChooseUnity,
    CurrentLogin,
    LoggedUser
  }
};
</script>

<style lang="scss" scoped>

.card{
    width: 380px;
    min-height: 300px;
    border: 1px solid rgb(253, 248, 248);
    border-radius: 15px;
    padding: 30px;
}

.password__layout {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  height: 100%;
  background: #ffffff;
}

.password__layout__system {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.password__layout__card {
  width: 380px;
  min-height: 300px;
  padding: 30px;
  background: #ffffff;
  border: 1px solid gray;
  border-radius: 15px;
}

.steps__main {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 25px;
  position: absolute;  
  top: 50%;  
  left: 50%;  
  transform: translate(-50%, -50%);  
  width: 100%;  
  height: 100%;  
  .step__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    width: 100%;

    h5 {
    font-size: 14px;
    font-weight: 700;

    .firstNameLetter {
        text-transform: capitalize;
    }
    }
  }
}
</style>